import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    black: "#1D2227",
    darkGrey: "#434850",
    spotifyGreen: "#3EDF85",
    disneyPurple: "#5961DE",
    white: "#F5FAFF",
    netflix: "#D95D5D",
    yellow: "#F7D642",
    midGrey: "#7E8897",
    filminGrey: "#646464",
    movistarBlue: "#71C9FD",
    gradientBlue: "#0078FF",
    google: {
      100: "#faebee",
      200: "#f4ced4",
      300: "#df9d9f",
      400: "#d0787b",
      500: "#d95d5d",
      600: "#dd5048",
      700: "#ce4846",
      800: "#bc403f",
      900: "#ae3b39",
    },
    pulpoGreen: {
      100: "#e2faea",
      200: "#e2faea",
      300: "#b9f1cb",
      400: "#87e8a9",
      500: "#3edf84",
      600: "#00d666",
      700: "#00cc4d",
      800: "#00bb43",
      900: "#00a836",
    },
    pulpoBlue: {
      100: "#e3e9ff",
      200: "#e3e9ff",
      300: "#e3e9ff",
      400: "#b7c7ff",
      500: "#80a4ff",
      600: "#3b81f7",
      700: "#0065ea",
      800: "#004bdd",
      900: "#0043d3",
    },
    emailBlack: {
      100: "#bec4cd",
      200: "#a0a5af",
      300: "#767c85",
      400: "#626770",
      500: "#434850",
      600: "#22262e",
      700: "#22262e",
      800: "#22262e",
      900: "#22262e",
    },
    pulpoOrange: {
      100: "#fceb55",
      200: "#fae635",
      300: "#fdd835",
      400: "#fbc02d",
      500: "#f9a825",
      600: "#f57f17",
      700: "#f57f17",
      800: "#f57f17",
      900: "#f57f17",
    },
    pulpoGray: {
      100: "#acacac",
      200: "#8b8b8b",
      300: "#646464",
      400: "#515151",
      500: "#8b8b8b",
      600: "#131313",
      700: "#131313",
      800: "#131313",
      900: "#131313",
    },
    pulpoDarkGray: {
      100: "#DEE8F3",
      200: "#DEE8F3",
      300: "#DEE8F3",
      400: "#DEE8F3",
      500: "#DEE8F3",
      600: "#DEE8F3",
      700: "#DEE8F3",
      800: "#DEE8F3",
      900: "#DEE8F3",
    },
  },
  fonts: {
    body: "'Raleway', sans-serif",
    heading: "'Raleway', sans-serif",
  },
  textStyles: {
    bodyHeavy: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 900,
    },
    bodyHeavyLine: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 900,
      textDecoration: "line-through",
      color: "#B0B8C6",
      textDecorationThickness: "2px",
    },
    bodyHeavyBig: {
      fontSize: "36px",
      lineHeight: "42px",
      fontWeight: 800,
    },
    bodySmall: {
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: 500,
    },
    paraDraft: {
      fontSize: "18px",
      lineHeight: "150%",
      fontWeight: "normal",
    },
    button: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 900,
    },
    body: {
      fontSize: "18px",
      lineHeight: "150%",
      fontWeight: "normal",
    },
    mainTitle: {
      fontSize: ["18px", "18px", "18px", "36px"],
      lineHeight: ["21px", "21px", "21px", "42px"],
      fontWeight: 900,
    },
    navBarTitle: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 500,
    },
    navBarSelected: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: 900,
    },
    buttonSmall: {
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: 900,
    },
    smallBold: {
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: "bold",
    },
    subTitle: {
      fontSize: "24px",
      lineHeight: "28px",
      fontWeight: 900,
    },
    siteTitle: {
      fontSize: "48px",
      fontWeight: 900,
      lineHeight: "56px",
    },
    buttonMobile: {
      fontSize: "16px",
      fontWeight: 800,
      lineHeight: "18px",
    },
    bodySmallMobile: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "14px",
    },
    bodyMobile: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    navBarMobile: {
      fontSize: "10px",
      fontWeight: 500,
      lineHeight: "12px",
    },
    bodyHeavyMobile: {
      fontSize: "16px",
      fontWeight: 800,
      lineHeight: "19px",
    },
    titleMobile: {
      fontSize: "24px",
      fontWeight: 800,
      lineHeight: "28px",
    },
    subtitleMobile: {
      fontSize: "14px",
      fontWeight: 800,
      lineHeight: "17px",
    },
  },
  components: {
    Input: {
      variants: {
        rounded: {
          borderRadius: "26px",
          border: "3px solid #DEE8F3",
        },
      },
    },
    Button: {
      variants: {
        pulpo: {
          borderRadius: "26px",
          minWidth: "125px",
        },
        brand: {
          background: "linear-gradient(180deg, #0078FF 0%, #00ACFF 100%)",
          borderRadius: "26px",
          minWidth: "200px",
        },
      },
    },
  },
});
